import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { adminAction,  } from '../../../../redux/actions/index';
// import { toast } from 'react-toastify';

import './roomReportTotal.css';
import './dashboard.css';

import { reportTotalBranchData, reportTotalBranchData2, reportTotalMembership, } from '../../../../api/other/reportAdmin'
import RoomReportTotalItem from '../../../../components/Postion/Admin/RoomReportTotal/RoomReportTotalItem';
import RoomReportTotalAreaBranch from '../../../../components/Postion/Admin/RoomReportTotal/RoomReportTotalAreaBranch';
import RoomReportTotalAreaBranchByGemini from '../../../../components/Postion/Admin/RoomReportTotal/Gemini/RoomReportTotalAreaBranch';

import { changeDateToString, getTodayMonth } from '../../../../utils/Date/SupportDate'
import { coverIDToFullName } from '../../../../utils/Branch/SupportBranch';

import { showLoading, hideLoading } from '../../../../actions/ui';
import ReportMemberShipAdmin from '../../../../components/Postion/Admin/MemberShip/ReportMemberShipAdmin';
import MultiBranchSelect from '../../../../features/MultiBranchSelect';
import RoomReportTotalItem2 from '../../../../components/Postion/Admin/RoomReportTotal/RoomReportTotalItem2';
import VoucherMemberShip from '../../../../components/Postion/Admin/MemberShip/VoucherMemberShip';
import VerticalMenu from '../../../../components/Units/VerticalMenu';


const RoomReportTotal = () => {
  const [currentDate1, setCurrentDate1] = useState("");
  const [currentDate2, setCurrentDate2] = useState("");
  const [active, setActive] = useState(null);

  const [days1, setDays1] = useState([]);
  const [days2, setDays2] = useState([]);
  const [dayOld1, setDayOld1] = useState([]);
  const [dayOld2, setDayOld2] = useState([]);

  const [option1, setOption1] = useState(false);

  const [dataBranch, setDataBranch] = useState({
      area: "Select Area",
      branch: "Select Branch",
      branchID: 0,
      name: "",
      room: 0,
      month: getTodayMonth()
  });
  
  const dispatch = useDispatch();

  const reportTotal = useSelector(state => state.reportTotal);
  const token = useSelector(state => state.token);
  const user = useSelector(state => state.auth.user);
  const { role, area } = user;
  const { viewRoom } = reportTotal;
  const isMultiBranch = (role === 5 || role === 6 || role === 7 || role === 8 || role === 1);
  const isMultiArea = (role === 7 || role === 1 || role === 8);

  const dayNames2 = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat","Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Mon", "Tue", ];

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const allBranchInform = useSelector(state => state.allBranchInformation);
  const listArea = allBranchInform === undefined ? [] : Object.keys(allBranchInform);
 // var listBranch = renderListBranch(dataBranch.area)
  var listBranch = (role === 6) ? renderListBranch(area) : (role === 7) ? renderListBranch(dataBranch.area) : [];

  useEffect(() => {
    if(!isMultiBranch && role) {
        setDataBranch({
          ...dataBranch, 
          area: user.area,
          branch: "",
          name: coverIDToFullName(user.branchID),
          branchID: user.branchID,
        })
    } 
  },[role]);

  function renderListBranch(areaValue) {
      let list = [];
      if(areaValue) {
        if (JSON.stringify(allBranchInform) !== '{}' && areaValue !== "Select Area") {
            allBranchInform[areaValue].forEach(branch => {
                list.push(branch.name);
            })
        } else {
            list = []
        }
      }

      return list;
  }

  function onChangeData(target, value, index) {
        const newData = {...dataBranch};

        if(target === "branch") {
            if(reportTotal.typeTabMenuSelect === "REPORT BRANCH") resetDataWithTarget("viewRoom", "Branch")
            else setDays1([]); setDays2([]);

            newData.branchID  = allBranchInform[(isMultiBranch && newData.area !== "Select Area") ? newData.area : user.area][index].branchID;
            newData[target] = value;
            newData["month"] = "";
        } else if (target ==="month"){
            if(viewRoom.content.length > 0){
              if(reportTotal.typeTabMenuSelect === "REPORT BRANCH") resetDataWithTarget("viewRoom", "Branch")
              else  setDays1([]); setDays2([]);
             // if(reportTotal.typeTabMenuSelect === "Calender") resetDataWithTarget("viewRoom", "Branch")

              // else resetDataWithTarget("viewRoom", "Branch")
            }
            newData[target] = value;
        } else {
            newData[target] = value;
        }

        setDataBranch(newData);
  }
  
  function changeSelectArea(value, index) {onChangeData("area", value, index) }
  function changeSelectBranchID(value, index) {onChangeData("branch", value, index) }

  const getBackgroundColor = (percent) => {
    if (percent >= 90) return 'red';
    if (percent >= 80) return 'orange';
    if (percent >= 70) return 'yellow';
    if (percent >= 60) return 'green';
    return 'white';
  };

  function normalizeAreaForApi(areaValue) {
    if (!areaValue) return areaValue;
    if (areaValue === "Hai Phong / Da Nang" || areaValue === "Hai_Phong_/_Da_Nang" || areaValue === "Hai_Phong_Da_Nang") {
      return "Hai_Phong_Da_Nang";
    }
    if (areaValue === "Cam/Man" || areaValue === "Cam_Man") {
      return "Cam_Man";
    }
    return areaValue;
  }

  function isHoChiMinhArea(areaValue) {
    const raw = String(areaValue || "").toLowerCase();
    const normalized = raw.replace(/[^a-z0-9]/g, "");
    return normalized.includes("hochiminh") || normalized.includes("hcm");
  }

  function resolveAreaKey(areaValue) {
    const areaKeys = Object.keys(allBranchInform || {});
    if (!areaValue || areaKeys.length === 0) return null;

    if (areaKeys.includes(areaValue)) return areaValue;

    const withSpace = String(areaValue).replace(/_/g, " ");
    if (areaKeys.includes(withSpace)) return withSpace;

    const normalize = (s) => String(s || "").toLowerCase().replace(/[^a-z0-9]/g, "");
    const target = normalize(areaValue);
    return areaKeys.find((k) => normalize(k) === target) || null;
  }

  function shouldIncludeBranchInAllAreaReport(branch) {
    const branchId = Number(branch?.branchID || 0);
    return branchId > 0 && branchId !== 2 && branchId !== 10 && branchId !== 11 && branchId <= 90;
  }

  function getPreviousMonthValue(month) {
    if (!month) return null;

    const [yearText, monthText] = String(month).split('-');
    const year = Number(yearText);
    const monthNumber = Number(monthText);

    if (!year || !monthNumber) return null;

    const previousMonthDate = new Date(year, monthNumber - 2, 1);
    return `${previousMonthDate.getFullYear()}-${String(previousMonthDate.getMonth() + 1).padStart(2, '0')}`;
  }

  function attachPreviousMonthSummary(viewData, previousMonthData, reportMonth) {
    return {
      ...viewData,
      reportMonth,
      previousMonthSummary: previousMonthData
        ? {
            ...previousMonthData,
            reportMonth: getPreviousMonthValue(reportMonth)
          }
        : null,
    };
  }

  function mergeAreaViewRoom(listData, areaLabel) {
    const numericKeys = [
      "room", "roomTotal", "capacity", "femaleTotal", "OTATotal", "memberShipTotal", "companyTotal",
      "fromAzWebTotal", "fromAzAppTotal", "pickUpTotal", "dropOffTotal", "waitingListTotal", "cancelListTotal",
      "surveyTotal", "totalRoten", "totalBF", "totalMassage", "totalShortTime", "totalNoshow", "totalCancelRoom",
      "totalRoomLine"
    ];

    const merged = {
      branchName: `${areaLabel} - All Branches`,
      areaName: areaLabel,
      reportScope: "AREA",
      OTATotalDetails: {},
      dataCapacityMonth: [],
      dataCapacityMonthArea: [],
      content: []
    };

    let capacitySum = 0;
    let capacityCount = 0;
    const contentByDate = {};

    listData.forEach((view) => {
      if (!view) return;

      numericKeys.forEach((key) => {
        if (key === "capacity") return;
        merged[key] = (merged[key] || 0) + (Number(view[key]) || 0);
      });

      if (view.capacity !== null && view.capacity !== undefined && !Number.isNaN(Number(view.capacity))) {
        capacitySum += Number(view.capacity);
        capacityCount += 1;
      }

      Object.entries(view.OTATotalDetails || {}).forEach(([channel, value]) => {
        merged.OTATotalDetails[channel] = (merged.OTATotalDetails[channel] || 0) + (Number(value) || 0);
      });

      if (Array.isArray(view.dataCapacityMonth)) {
        view.dataCapacityMonth.forEach((value, idx) => {
          merged.dataCapacityMonth[idx] = (merged.dataCapacityMonth[idx] || 0) + (Number(value) || 0);
        });
      }

      if (Array.isArray(view.dataCapacityMonthArea)) {
        view.dataCapacityMonthArea.forEach((dataset, dsIndex) => {
          const key = dataset?.label || `dataset_${dsIndex}`;
          const existingIndex = merged.dataCapacityMonthArea.findIndex((d) => (d.label || `dataset_${d._index}`) === key);

          if (existingIndex === -1) {
            const newData = Array.isArray(dataset?.data) ? dataset.data.map((v) => Number(v) || 0) : [];
            merged.dataCapacityMonthArea.push({
              ...dataset,
              _index: dsIndex,
              data: newData
            });
          } else {
            const current = merged.dataCapacityMonthArea[existingIndex];
            const src = Array.isArray(dataset?.data) ? dataset.data : [];
            const maxLen = Math.max(current.data?.length || 0, src.length);
            const nextData = Array.from({ length: maxLen }).map((_, i) =>
              (Number(current.data?.[i]) || 0) + (Number(src[i]) || 0)
            );
            merged.dataCapacityMonthArea[existingIndex] = {
              ...current,
              data: nextData
            };
          }
        });
      }

      if (Array.isArray(view.content)) {
        view.content.forEach((day) => {
          const dateKey = day?.data || day?.date;
          if (!dateKey) return;

          if (!contentByDate[dateKey]) {
            contentByDate[dateKey] = {
              ...day,
              data: dateKey,
              guestNumber: Number(day.guestNumber) || 0,
              short_time: Number(day.short_time) || 0,
              check_in: Number(day.check_in) || 0,
              check_out: Number(day.check_out) || 0,
              female: Number(day.female) || 0,
              OTAOnDay: Number(day.OTAOnDay) || 0,
              late_out: Number(day.late_out) || 0,
              list_short: Array.isArray(day.list_short) ? [...day.list_short] : [],
              list_lateOut: Array.isArray(day.list_lateOut) ? [...day.list_lateOut] : [],
              OTADetailsOnDay: { ...(day.OTADetailsOnDay || {}) }
            };
            return;
          }

          const current = contentByDate[dateKey];
          current.guestNumber += Number(day.guestNumber) || 0;
          current.short_time += Number(day.short_time) || 0;
          current.check_in += Number(day.check_in) || 0;
          current.check_out += Number(day.check_out) || 0;
          current.female += Number(day.female) || 0;
          current.OTAOnDay += Number(day.OTAOnDay) || 0;
          current.late_out += Number(day.late_out) || 0;

          if (Array.isArray(day.list_short)) {
            current.list_short = [...current.list_short, ...day.list_short];
          }
          if (Array.isArray(day.list_lateOut)) {
            current.list_lateOut = [...current.list_lateOut, ...day.list_lateOut];
          }

          Object.entries(day.OTADetailsOnDay || {}).forEach(([channel, value]) => {
            current.OTADetailsOnDay[channel] = (Number(current.OTADetailsOnDay[channel]) || 0) + (Number(value) || 0);
          });
        });
      }
    });

    merged.capacity = capacityCount > 0 ? Math.round((capacitySum / capacityCount) * 100) / 100 : 0;
    merged.dataCapacityMonthArea = merged.dataCapacityMonthArea.map(({ _index, ...rest }) => rest);
    merged.content = Object.values(contentByDate).sort((a, b) => String(a.data).localeCompare(String(b.data)));

    return merged;
  }

  function onLoadDataRoomReportTotalAreaBranch(branchId, area, month) {
      const isYearlyMode = /^\d{4}$/.test(String(month || ""));
      const selectedMonths = isYearlyMode ? getYearMonthList(month) : [month];
      const previousMonth = getPreviousMonthValue(month);

      const loadGuestNumber = async () => {
         dispatch(showLoading())
        const branchOnLoad = role === 2 ? user.branchID : branchId;
        const areaOnLoad = role === 2
        ? normalizeAreaForApi(user.area)
        : normalizeAreaForApi(area);

        try {
          const monthRequests = selectedMonths.map((targetMonth) => reportTotalBranchData(branchOnLoad, targetMonth, areaOnLoad, token));
          const previousMonthRequests = previousMonth
            ? [reportTotalBranchData(branchOnLoad, previousMonth, areaOnLoad, token)]
            : [];

          const results = await Promise.all(monthRequests);
          const previousMonthResult = previousMonthRequests.length > 0 ? await previousMonthRequests[0] : null;

          const listView = results.map((res) => res?.data?.data).filter(Boolean);
          const viewData = isYearlyMode
            ? mergeYearlyViewRoom(listView, `${month} Summary`)
            : { ...results[0].data.data };

          if (isYearlyMode) {
            viewData.reportMonth = month;
            viewData.previousMonthSummary = previousMonthResult?.data?.data
              ? { ...previousMonthResult.data.data, reportMonth: previousMonth }
              : null;

            const latestDetail = listView[listView.length - 1] || null;
            const monthly = selectedMonths.map((monthKey, idx) => ({
              month: monthKey,
              capacity: Number(listView?.[idx]?.capacity) || 0,
            }));
            const monthlyOta = selectedMonths.map((monthKey, idx) => ({
              month: monthKey,
              otaTotal: Number(listView?.[idx]?.OTATotal) || 0,
            }));
            const capacityValues = monthly
              .map((item) => Number(item.capacity) || 0)
              .filter((value) => Number.isFinite(value));

            viewData.areaBranchDetails = [
              {
                branchID: Number(branchOnLoad) || 0,
                branchName: latestDetail?.branchInformation?.name || coverIDToFullName(branchOnLoad) || "Selected Branch",
                areaName: latestDetail?.branchInformation?.area || areaOnLoad || "",
                capacity: capacityValues.length > 0
                  ? Math.round((capacityValues.reduce((sum, value) => sum + value, 0) / capacityValues.length) * 100) / 100
                  : 0,
                roomTotal: listView.reduce((sum, detail) => sum + (Number(detail?.roomTotal) || 0), 0),
                companyTotal: listView.reduce((sum, detail) => sum + (Number(detail?.companyTotal) || 0), 0),
                OTATotal: listView.reduce((sum, detail) => sum + (Number(detail?.OTATotal) || 0), 0),
                memberShipTotal: listView.reduce((sum, detail) => sum + (Number(detail?.memberShipTotal) || 0), 0),
                femaleTotal: listView.reduce((sum, detail) => sum + (Number(detail?.femaleTotal) || 0), 0),
                fromAzAppTotal: listView.reduce((sum, detail) => sum + (Number(detail?.fromAzAppTotal) || 0), 0),
                fromAzWebTotal: listView.reduce((sum, detail) => sum + (Number(detail?.fromAzWebTotal) || 0), 0),
                pickUpTotal: listView.reduce((sum, detail) => sum + (Number(detail?.pickUpTotal) || 0), 0),
                dropOffTotal: listView.reduce((sum, detail) => sum + (Number(detail?.dropOffTotal) || 0), 0),
                cancelListTotal: listView.reduce((sum, detail) => sum + (Number(detail?.cancelListTotal) || 0), 0),
                waitingListTotal: listView.reduce((sum, detail) => sum + (Number(detail?.waitingListTotal) || 0), 0),
                surveyTotal: listView.reduce((sum, detail) => sum + (Number(detail?.surveyTotal) || 0), 0),
                totalRoomLine: listView.reduce((sum, detail) => sum + (Number(detail?.totalRoomLine) || 0), 0),
                totalRoten: listView.reduce((sum, detail) => sum + (Number(detail?.totalRoten) || 0), 0),
                totalBF: listView.reduce((sum, detail) => sum + (Number(detail?.totalBF) || 0), 0),
                totalMassage: listView.reduce((sum, detail) => sum + (Number(detail?.totalMassage) || 0), 0),
                OTATotalDetails: listView.reduce((acc, detail) => {
                  Object.entries(detail?.OTATotalDetails || {}).forEach(([channel, value]) => {
                    acc[channel] = (acc[channel] || 0) + (Number(value) || 0);
                  });
                  return acc;
                }, {}),
                monthly,
                monthlyOta,
              }
            ];
          } else {
            Object.assign(viewData, attachPreviousMonthSummary(
              { ...viewData },
              previousMonthResult?.data?.data || null,
              month
            ));
          }

          dispatch(adminAction.fetchAdminReportTotalWithTarget({data: viewData, target: "viewRoom"}))
        } finally {
          dispatch(hideLoading());
        }
      }

      const loadAreaSummary = async () => {
        dispatch(showLoading());

        const areaKey = resolveAreaKey(area);
        const areaApi = normalizeAreaForApi(areaKey || area);
        const isHcm = isHoChiMinhArea(areaKey || area);

        const branchesInArea = (allBranchInform?.[areaKey] || [])
          .filter((b) => b?.branchID)
          .filter((b) => Number(b?.branchID) !== 10)
          .filter((b) => !(isHcm && Number(b?.branchID) === 2))
          .filter((b) => Number(b?.branchID) !== 11)
          .filter((b) => Number(b?.branchID) <= 90)
          .filter((b) => !/test/i.test(String(b?.name || "")));

        if (!areaKey || branchesInArea.length === 0) {
          dispatch(hideLoading());
          return;
        }

        try {
          const monthResponses = await Promise.all(
            selectedMonths.map((targetMonth) =>
              Promise.all(branchesInArea.map((b) => reportTotalBranchData(b.branchID, targetMonth, areaApi, token)))
            )
          );

          const previousMonthResponses = previousMonth
            ? await Promise.all(branchesInArea.map((b) => reportTotalBranchData(b.branchID, previousMonth, areaApi, token)))
            : [];

          const listView = monthResponses.flat().map((res) => res?.data?.data).filter(Boolean);
          const previousListView = previousMonthResponses.map((res) => res?.data?.data).filter(Boolean);
          const mergedView = isYearlyMode
            ? mergeYearlyViewRoom(listView, `${month} - ${areaKey}`)
            : mergeAreaViewRoom(listView, areaKey);

          const baseView = isYearlyMode ? mergedView : attachPreviousMonthSummary(
            mergeAreaViewRoom(listView, areaKey),
            previousListView.length > 0 ? mergeAreaViewRoom(previousListView, areaKey) : null,
            month
          );

          const finalView = isYearlyMode
            ? {
                ...baseView,
                reportMonth: month,
                previousMonthSummary: previousMonthResponses.length > 0
                  ? { ...mergeAreaViewRoom(previousListView, areaKey), reportMonth: previousMonth }
                  : null,
              }
            : baseView;

          finalView.areaBranchDetails = branchesInArea
            .map((branch, idx) => {
              const detailsByMonth = monthResponses
                .map((monthSet) => monthSet?.[idx]?.data?.data)
                .filter(Boolean);

              const latestDetail = detailsByMonth[detailsByMonth.length - 1] || null;
              const branchName = latestDetail?.branchInformation?.name || branch?.name || `Branch ${branch?.branchID || ""}`;
              const branchId = Number(branch?.branchID) || 0;

              if (!isYearlyMode) {
                const monthly = Array.isArray(latestDetail?.dataBranchMonth)
                  ? latestDetail.dataBranchMonth.map((m) => ({
                      month: m?.month,
                      capacity: Number(m?.capacity) || 0,
                    }))
                  : [];

                return {
                  branchID: branchId,
                  branchName,
                  areaName: branch?.area || areaKey || "",
                  capacity: Number(latestDetail?.capacity) || 0,
                  roomTotal: Number(latestDetail?.roomTotal) || 0,
                  companyTotal: Number(latestDetail?.companyTotal) || 0,
                  OTATotal: Number(latestDetail?.OTATotal) || 0,
                  memberShipTotal: Number(latestDetail?.memberShipTotal) || 0,
                  femaleTotal: Number(latestDetail?.femaleTotal) || 0,
                  fromAzAppTotal: Number(latestDetail?.fromAzAppTotal) || 0,
                  fromAzWebTotal: Number(latestDetail?.fromAzWebTotal) || 0,
                  pickUpTotal: Number(latestDetail?.pickUpTotal) || 0,
                  dropOffTotal: Number(latestDetail?.dropOffTotal) || 0,
                  cancelListTotal: Number(latestDetail?.cancelListTotal) || 0,
                  waitingListTotal: Number(latestDetail?.waitingListTotal) || 0,
                  surveyTotal: Number(latestDetail?.surveyTotal) || 0,
                  totalRoomLine: Number(latestDetail?.totalRoomLine) || 0,
                  totalRoten: Number(latestDetail?.totalRoten) || 0,
                  totalBF: Number(latestDetail?.totalBF) || 0,
                  totalMassage: Number(latestDetail?.totalMassage) || 0,
                  OTATotalDetails: { ...(latestDetail?.OTATotalDetails || {}) },
                  monthly,
                };
              }

              const monthly = selectedMonths.map((m, monthIndex) => ({
                month: m,
                capacity: Number(monthResponses?.[monthIndex]?.[idx]?.data?.data?.capacity) || 0,
              }));
              const monthlyOta = selectedMonths.map((m, monthIndex) => ({
                month: m,
                otaTotal: Number(monthResponses?.[monthIndex]?.[idx]?.data?.data?.OTATotal) || 0,
              }));

              const capacityValues = monthly.map((item) => Number(item.capacity) || 0).filter((value) => Number.isFinite(value));
              const sumField = (key) => detailsByMonth.reduce((sum, detail) => sum + (Number(detail?.[key]) || 0), 0);
              const otaTotalDetails = {};
              detailsByMonth.forEach((detail) => {
                Object.entries(detail?.OTATotalDetails || {}).forEach(([channel, value]) => {
                  otaTotalDetails[channel] = (otaTotalDetails[channel] || 0) + (Number(value) || 0);
                });
              });

              return {
                branchID: branchId,
                branchName,
                areaName: branch?.area || areaKey || "",
                capacity: capacityValues.length > 0
                  ? Math.round((capacityValues.reduce((sum, value) => sum + value, 0) / capacityValues.length) * 100) / 100
                  : 0,
                roomTotal: sumField("roomTotal"),
                companyTotal: sumField("companyTotal"),
                OTATotal: sumField("OTATotal"),
                memberShipTotal: sumField("memberShipTotal"),
                femaleTotal: sumField("femaleTotal"),
                fromAzAppTotal: sumField("fromAzAppTotal"),
                fromAzWebTotal: sumField("fromAzWebTotal"),
                pickUpTotal: sumField("pickUpTotal"),
                dropOffTotal: sumField("dropOffTotal"),
                cancelListTotal: sumField("cancelListTotal"),
                waitingListTotal: sumField("waitingListTotal"),
                surveyTotal: sumField("surveyTotal"),
                totalRoomLine: sumField("totalRoomLine"),
                totalRoten: sumField("totalRoten"),
                totalBF: sumField("totalBF"),
                totalMassage: sumField("totalMassage"),
                OTATotalDetails: otaTotalDetails,
                monthly,
                monthlyOta,
              };
            })
            .filter(Boolean);

          dispatch(adminAction.fetchAdminReportTotalWithTarget({data: finalView, target: "viewRoom"}));
        } finally {
          dispatch(hideLoading());
        }
      }

      const loadAllBranchSummary = async () => {
        dispatch(showLoading());

        const branchesInAllAreas = Object.values(allBranchInform || {})
          .flat()
          .filter((branch, index, array) => array.findIndex((item) => Number(item?.branchID) === Number(branch?.branchID)) === index)
          .filter(shouldIncludeBranchInAllAreaReport);

        if (branchesInAllAreas.length === 0) {
          dispatch(hideLoading());
          return;
        }

        try {
          const monthResponses = await Promise.all(
            selectedMonths.map((targetMonth) =>
              Promise.all(
                branchesInAllAreas.map((branch) => reportTotalBranchData(branch.branchID, targetMonth, normalizeAreaForApi(branch.area), token))
              )
            )
          );

          const previousMonthResponses = previousMonth
            ? await Promise.all(
                branchesInAllAreas.map((branch) => reportTotalBranchData(branch.branchID, previousMonth, normalizeAreaForApi(branch.area), token))
              )
            : [];

          const listView = monthResponses.flat().map((res) => res?.data?.data).filter(Boolean);
          const previousListView = previousMonthResponses.map((res) => res?.data?.data).filter(Boolean);
          const mergedView = isYearlyMode
            ? mergeYearlyViewRoom(listView, `${month} - All Areas`)
            : mergeAreaViewRoom(listView, "All Areas");

          const finalView = isYearlyMode
            ? {
                ...mergedView,
                branchName: "All Areas - All Branches",
                areaName: "All Areas",
                reportMonth: month,
                previousMonthSummary: previousMonthResponses.length > 0
                  ? { ...mergeAreaViewRoom(previousListView, "All Areas"), branchName: "All Areas - All Branches", reportMonth: previousMonth }
                  : null,
              }
            : attachPreviousMonthSummary(
                mergeAreaViewRoom(listView, "All Areas"),
                previousListView.length > 0 ? mergeAreaViewRoom(previousListView, "All Areas") : null,
                month
              );

          finalView.branchName = "All Areas - All Branches";
          finalView.areaName = "All Areas";
          finalView.areaBranchDetails = branchesInAllAreas
            .map((branchInfo, idx) => {
              const detailsByMonth = monthResponses
                .map((monthSet) => monthSet?.[idx]?.data?.data)
                .filter(Boolean);

              const latestDetail = detailsByMonth[detailsByMonth.length - 1] || null;

              if (!isYearlyMode) {
                const monthly = Array.isArray(latestDetail?.dataBranchMonth)
                  ? latestDetail.dataBranchMonth.map((m) => ({
                      month: m?.month,
                      capacity: Number(m?.capacity) || 0,
                    }))
                  : [];

                return {
                  branchID: Number(branchInfo.branchID) || 0,
                  branchName: latestDetail?.branchInformation?.name || branchInfo.name || `Branch ${branchInfo?.branchID || ""}`,
                  areaName: branchInfo.area || "",
                  capacity: Number(latestDetail?.capacity) || 0,
                  roomTotal: Number(latestDetail?.roomTotal) || 0,
                  companyTotal: Number(latestDetail?.companyTotal) || 0,
                  OTATotal: Number(latestDetail?.OTATotal) || 0,
                  memberShipTotal: Number(latestDetail?.memberShipTotal) || 0,
                  femaleTotal: Number(latestDetail?.femaleTotal) || 0,
                  fromAzAppTotal: Number(latestDetail?.fromAzAppTotal) || 0,
                  fromAzWebTotal: Number(latestDetail?.fromAzWebTotal) || 0,
                  pickUpTotal: Number(latestDetail?.pickUpTotal) || 0,
                  dropOffTotal: Number(latestDetail?.dropOffTotal) || 0,
                  cancelListTotal: Number(latestDetail?.cancelListTotal) || 0,
                  waitingListTotal: Number(latestDetail?.waitingListTotal) || 0,
                  surveyTotal: Number(latestDetail?.surveyTotal) || 0,
                  totalRoomLine: Number(latestDetail?.totalRoomLine) || 0,
                  totalRoten: Number(latestDetail?.totalRoten) || 0,
                  totalBF: Number(latestDetail?.totalBF) || 0,
                  totalMassage: Number(latestDetail?.totalMassage) || 0,
                  OTATotalDetails: { ...(latestDetail?.OTATotalDetails || {}) },
                  monthly,
                };
              }

              const monthly = selectedMonths.map((m, monthIndex) => ({
                month: m,
                capacity: Number(monthResponses?.[monthIndex]?.[idx]?.data?.data?.capacity) || 0,
              }));
              const monthlyOta = selectedMonths.map((m, monthIndex) => ({
                month: m,
                otaTotal: Number(monthResponses?.[monthIndex]?.[idx]?.data?.data?.OTATotal) || 0,
              }));

              const capacityValues = monthly.map((item) => Number(item.capacity) || 0).filter((value) => Number.isFinite(value));
              const sumField = (key) => detailsByMonth.reduce((sum, detail) => sum + (Number(detail?.[key]) || 0), 0);
              const otaTotalDetails = {};
              detailsByMonth.forEach((detail) => {
                Object.entries(detail?.OTATotalDetails || {}).forEach(([channel, value]) => {
                  otaTotalDetails[channel] = (otaTotalDetails[channel] || 0) + (Number(value) || 0);
                });
              });

              return {
                branchID: Number(branchInfo.branchID) || 0,
                branchName: latestDetail?.branchInformation?.name || branchInfo.name || `Branch ${branchInfo?.branchID || ""}`,
                areaName: branchInfo.area || "",
                capacity: capacityValues.length > 0
                  ? Math.round((capacityValues.reduce((sum, value) => sum + value, 0) / capacityValues.length) * 100) / 100
                  : 0,
                roomTotal: sumField("roomTotal"),
                companyTotal: sumField("companyTotal"),
                OTATotal: sumField("OTATotal"),
                memberShipTotal: sumField("memberShipTotal"),
                femaleTotal: sumField("femaleTotal"),
                fromAzAppTotal: sumField("fromAzAppTotal"),
                fromAzWebTotal: sumField("fromAzWebTotal"),
                pickUpTotal: sumField("pickUpTotal"),
                dropOffTotal: sumField("dropOffTotal"),
                cancelListTotal: sumField("cancelListTotal"),
                waitingListTotal: sumField("waitingListTotal"),
                surveyTotal: sumField("surveyTotal"),
                totalRoomLine: sumField("totalRoomLine"),
                totalRoten: sumField("totalRoten"),
                totalBF: sumField("totalBF"),
                totalMassage: sumField("totalMassage"),
                OTATotalDetails: otaTotalDetails,
                monthly,
                monthlyOta,
              };
            })
            .filter(Boolean);

          dispatch(adminAction.fetchAdminReportTotalWithTarget({data: finalView, target: "viewRoom"}));
        } finally {
          dispatch(hideLoading());
        }
      }

      if(reportTotal.typeTabMenuSelect === "REPORT BRANCH") {
          const areaKey = resolveAreaKey(area);
          const shouldLoadAreaSummary = (!branchId || Number(branchId) === 0) && !!areaKey;
          const shouldLoadAllSummary = (!branchId || Number(branchId) === 0) && !areaKey;

          if (shouldLoadAreaSummary) {
            loadAreaSummary();
          } else if (shouldLoadAllSummary) {
            loadAllBranchSummary();
          } else {
            loadGuestNumber();
          }
      }
  }

  function onLoadDataRoomReportTotalMembership() {
      const loadGuestNumber = async () => {
         dispatch(showLoading())
         const dataResult = await reportTotalMembership(token);
         dispatch(adminAction.fetchAdminReportTotalWithTarget({data: {...dataResult.data.data}, target: "memberShip" }))
         dispatch(hideLoading());
      }

      loadGuestNumber();
  }

  function resetData() { dispatch(adminAction.resetAdminReportTotal()); }
  
  function resetDataWithTarget(target, typeTabMenuSelect) { dispatch(adminAction.resetAdminReportTotalWithTraget({target, typeTabMenuSelect})); }

  function onChangeItem(target, value, index) {
    // console.log("action change")
    if(target === "typeTabMenuSelect" && value === "DETAILS") {
        onLoadDataRoomReportTotalMembership();
    }

    dispatch(adminAction.editAdminReportTotal({target, value, index}))
  }

  const loadDataCalenderOneMonth = async (date, type) => {
      //console.log("isMultiBranch", !isMultiBranch ? user.branchID :dataBranch.branchID,);
      dispatch(showLoading())

      //branchID, month, area, token
      const resultData = await reportTotalBranchData2(
        !isMultiBranch ? user.branchID :dataBranch.branchID,
         changeDateToString(date).slice(0,7),
         !isMultiArea ? user.area :
            dataBranch.area === "Hai Phong / Da Nang" ? "Hai_Phong_Da_Nang" :
             dataBranch.area === "Hai_Phong_/_Da_Nang" ? "Hai_Phong_Da_Nang" : 
               dataBranch.area === "Cam/Man" ? "Cam_Man" : 
                 dataBranch.area, "calendar", token);

      dispatch(hideLoading());

      setDataBranch({
        ...dataBranch,
        room: resultData.data.data.branchInformation.room,
        name: resultData.data.data.branchInformation.name,
      });

      //("resultData.data", resultData.data)

      if(type === "1") {
          if(reportTotal.typeTabMenuSelect === "CALENDAR 2") {
            setDays1(resultData.data.data.content); 
            setDayOld1(resultData.data.data.content2);
            setDayOld2(resultData.data.data.content3);
          } else setDays1(resultData.data.data.content); 
      } else {
        if(reportTotal.typeTabMenuSelect === "CALENDAR 2") {
          setDays2(resultData.data.data.content); 
          setDayOld2(resultData.data.data.content2);
          //  setDayOld2(resultData.data.data.content3);
        } else setDays2(resultData.data.data.content); 
      }
    }

  const handlePrev = (type) => {
    if(type==="1") {
      const prev = new Date(currentDate1.getFullYear(), currentDate1.getMonth() - 1, 1);
      setCurrentDate1(prev);
      // load 

      loadDataCalenderOneMonth(prev, type);
    } else {
      const prev = new Date(currentDate2.getFullYear(), currentDate2.getMonth() - 1, 1);
      setCurrentDate2(prev);
      // load 
      loadDataCalenderOneMonth(prev,  type);
    }

  };

  const handleNext = (type) => {

    const loadData = async (date) => {
      dispatch(showLoading())
      //const resultData = await checkCaptianOneMonth(dataBranch.branchID, changeDateToString(date).slice(0,7),  token);
      const resultData = await reportTotalBranchData2(
        !isMultiBranch  ? user.branchID :dataBranch.branchID,
         changeDateToString(date).slice(0,7),
         !isMultiArea? user.area :
             dataBranch.area === "Hai_Phong_/_Da_Nang" ? "Hai_Phong_Da_Nang" : 
               dataBranch.area === "Cam/Man" ? "Cam_Man" : 
                 dataBranch.area, "calendar", token);

      dispatch(hideLoading());
      if(type === "1") setDays1(resultData.data.arr1);
      else setDays2(resultData.data.arr1);
    }

    if(type==="1") {
      const next = new Date(currentDate1.getFullYear(), currentDate1.getMonth() + 1, 1);
      setCurrentDate1(next);
       loadDataCalenderOneMonth(next, type);
    } else {
      const next = new Date(currentDate2.getFullYear(), currentDate2.getMonth() + 1, 1);
      setCurrentDate2(next);
      //loadData(next);
       loadDataCalenderOneMonth(next, type);
    }
  };

  const handleMonthChange = (value, type) => {

    const [year, month] = value.split('-');
    const newDate = new Date(parseInt(year), parseInt(month) - 1, 1);

    if(type ==="1") setCurrentDate1(newDate);
    else setCurrentDate2(newDate);

    loadDataCalenderOneMonth(newDate, type);
  };

  function getYearMonthList(yearValue) {
    if (!yearValue) return [];
    const yearText = String(yearValue).match(/^(\d{4})/)?.[1];
    if (!yearText) return [];

    const year = Number(yearText);
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;

    const maxMonth = year < currentYear ? 12 : currentMonth;
    return Array.from({ length: maxMonth }, (_, index) => `${yearText}-${String(index + 1).padStart(2, '0')}`);
  }

  function mergeYearlyViewRoom(listData, title = "Yearly Summary") {
    const merged = {
      branchName: title,
      areaName: title,
      reportScope: "YEARLY",
      OTATotalDetails: {},
      dataCapacityMonth: [],
      dataCapacityMonthArea: [],
      content: [],
    };

    let capacitySum = 0;
    let capacityCount = 0;
    const contentByDate = {};
    const numericKeys = [
      "room", "roomTotal", "capacity", "femaleTotal", "OTATotal", "memberShipTotal", "companyTotal",
      "fromAzWebTotal", "fromAzAppTotal", "pickUpTotal", "dropOffTotal", "waitingListTotal", "cancelListTotal",
      "surveyTotal", "totalRoten", "totalBF", "totalMassage", "totalShortTime", "totalNoshow", "totalCancelRoom",
      "totalRoomLine"
    ];

    listData.forEach((view) => {
      if (!view) return;

      numericKeys.forEach((key) => {
        if (key === "capacity") return;
        merged[key] = (merged[key] || 0) + (Number(view[key]) || 0);
      });

      if (view.capacity !== null && view.capacity !== undefined && !Number.isNaN(Number(view.capacity))) {
        capacitySum += Number(view.capacity);
        capacityCount += 1;
      }

      Object.entries(view.OTATotalDetails || {}).forEach(([channel, value]) => {
        merged.OTATotalDetails[channel] = (merged.OTATotalDetails[channel] || 0) + (Number(value) || 0);
      });

      if (Array.isArray(view.dataCapacityMonth)) {
        view.dataCapacityMonth.forEach((value, idx) => {
          merged.dataCapacityMonth[idx] = (merged.dataCapacityMonth[idx] || 0) + (Number(value) || 0);
        });
      }

      if (Array.isArray(view.dataCapacityMonthArea)) {
        view.dataCapacityMonthArea.forEach((dataset, dsIndex) => {
          const key = dataset?.label || `dataset_${dsIndex}`;
          const existingIndex = merged.dataCapacityMonthArea.findIndex((d) => (d.label || `dataset_${d._index}`) === key);

          if (existingIndex === -1) {
            const newData = Array.isArray(dataset?.data) ? dataset.data.map((v) => Number(v) || 0) : [];
            merged.dataCapacityMonthArea.push({ ...dataset, _index: dsIndex, data: newData });
          } else {
            const current = merged.dataCapacityMonthArea[existingIndex];
            const src = Array.isArray(dataset?.data) ? dataset.data : [];
            const maxLen = Math.max(current.data?.length || 0, src.length);
            const nextData = Array.from({ length: maxLen }).map((_, i) =>
              (Number(current.data?.[i]) || 0) + (Number(src[i]) || 0)
            );
            merged.dataCapacityMonthArea[existingIndex] = { ...current, data: nextData };
          }
        });
      }

      if (Array.isArray(view.content)) {
        view.content.forEach((day) => {
          const dateKey = day?.data || day?.date;
          if (!dateKey) return;

          if (!contentByDate[dateKey]) {
            contentByDate[dateKey] = {
              ...day,
              data: dateKey,
              guestNumber: Number(day.guestNumber) || 0,
              short_time: Number(day.short_time) || 0,
              check_in: Number(day.check_in) || 0,
              check_out: Number(day.check_out) || 0,
              female: Number(day.female) || 0,
              OTAOnDay: Number(day.OTAOnDay) || 0,
              late_out: Number(day.late_out) || 0,
              list_short: Array.isArray(day.list_short) ? [...day.list_short] : [],
              list_lateOut: Array.isArray(day.list_lateOut) ? [...day.list_lateOut] : [],
              OTADetailsOnDay: { ...(day.OTADetailsOnDay || {}) }
            };
            return;
          }

          const current = contentByDate[dateKey];
          current.guestNumber += Number(day.guestNumber) || 0;
          current.short_time += Number(day.short_time) || 0;
          current.check_in += Number(day.check_in) || 0;
          current.check_out += Number(day.check_out) || 0;
          current.female += Number(day.female) || 0;
          current.OTAOnDay += Number(day.OTAOnDay) || 0;
          current.late_out += Number(day.late_out) || 0;

          if (Array.isArray(day.list_short)) current.list_short = [...current.list_short, ...day.list_short];
          if (Array.isArray(day.list_lateOut)) current.list_lateOut = [...current.list_lateOut, ...day.list_lateOut];

          Object.entries(day.OTADetailsOnDay || {}).forEach(([channel, value]) => {
            current.OTADetailsOnDay[channel] = (Number(current.OTADetailsOnDay[channel]) || 0) + (Number(value) || 0);
          });
        });
      }
    });

    merged.capacity = capacityCount > 0 ? Math.round((capacitySum / capacityCount) * 100) / 100 : 0;
    merged.dataCapacityMonthArea = merged.dataCapacityMonthArea.map(({ _index, ...rest }) => rest);
    merged.content = Object.values(contentByDate).sort((a, b) => String(a.data).localeCompare(String(b.data)));
    return merged;
  }

  return (
    <div className='d-flex'>
      <VerticalMenu 
          data={{
            // option1: "REPORT BRANCH",
            option1: "REPORT BRANCH",
            option2: "CALENDAR",
            option3: "CALENDAR 2",
            option4: "MEMBERSHIP",
            sub: {
              option1: "DETAILS",
              option2: "VOUCHER",
              option3: undefined,
              option4: undefined,

            },
          }}
          select = {reportTotal.typeTabMenuSelect}
          type = "typeTabMenuSelect"
          onChangeItem = {onChangeItem}
      />
       {/* <div className={'report-menu'}>
          {role!== 3 && <div className={(reportTotal.typeTabMenuSelect === "Branch" ? "active report-menu_item" : "report-menu_item")}
              onClick={() => onChangeItem("typeTabMenuSelect", "Branch", undefined)}>View Branch</div>}
          <div className={(reportTotal.typeTabMenuSelect === "Calender" ? "active report-menu_item" : "report-menu_item")}
              onClick={() => onChangeItem("typeTabMenuSelect", "Calender", undefined)}>Calendar</div>
          <div className={(reportTotal.typeTabMenuSelect === "Calender2" ? "active report-menu_item" : "report-menu_item")}
              onClick={() => onChangeItem("typeTabMenuSelect", "Calender2", undefined)}>Calendar 2 (demo Mr.Han)</div>
          {role!== 3 && <div className={(reportTotal.typeTabMenuSelect === "MemberShip" ? "active report-menu_item" : "report-menu_item")}
              onClick={() => onChangeItem("typeTabMenuSelect", "MemberShip", undefined)}>Member Ship</div>}
          {role!== 3 && <div className={(reportTotal.typeTabMenuSelect === "Voucher" ? "active report-menu_item" : "report-menu_item")}
              onClick={() => onChangeItem("typeTabMenuSelect", "Voucher", undefined)}>Voucher</div>}
       </div> */}
   
      {/* {
        reportTotal.typeTabMenuSelect === "REPORT BRANCH"
            && <RoomReportTotalAreaBranch 
                  resetData={resetData}
                  resetDataWithTarget={resetDataWithTarget}
                  onLoadData={onLoadDataRoomReportTotalAreaBranch}/>
      } */}

      {
        (reportTotal.typeTabMenuSelect === "REPORT BRANCH" && (role === 7 || role === 6) )
            && <RoomReportTotalAreaBranchByGemini 
                  resetData={resetData}
                  resetDataWithTarget={resetDataWithTarget}
                  onLoadData={onLoadDataRoomReportTotalAreaBranch}/>
      }

      { (reportTotal.typeTabMenuSelect === "CALENDAR" || reportTotal.typeTabMenuSelect === "CALENDAR 2"  ) && 
      <div style={{width:'90%'}}>
        <ul className="nav nav-sub row_freeze d-flex" id="test1" >
            <MultiBranchSelect
                listArea={listArea}
                listBranch={listBranch}
                changeSelectArea={changeSelectArea}
                changeSelectBranchID={changeSelectBranchID}
                selectArea={dataBranch.area}
                selectBranch={dataBranch.branch}
            />
        </ul>
        {dataBranch.branch === "Select Branch" ? "" :<div style={{width:'90%'}}>
          <h1>Compare capacity by month Branch: {dataBranch.branch === "Select Branch" ? isMultiBranch ? coverIDToFullName(user.branchID) : "" : dataBranch.branch}</h1>
          <div  className="color-rule">
            <h5 style={{color:"blue", cursor:'pointer'}}>Rule color?</h5>
            <div className="color-rule-details" style={{position:"absolute", right:'44%', background:'aqua',}}>
                <div className="rule-item"><span className="color-box red"></span> Capacity ≥ 90% → <strong>Red</strong></div>
                <div className="rule-item"><span className="color-box orange"></span> Capacity ≥ 80% → <strong>Orange</strong></div>
                <div className="rule-item"><span className="color-box yellow"></span> Capacity ≥ 70% → <strong>Yellow</strong></div>
                <div className="rule-item"><span className="color-box green"></span> Capacity ≥ 60% → <strong>Green</strong></div>
              </div>
          </div>
        </div>}

        {dataBranch.branch === "Select Branch" ? "" :<div className={reportTotal.typeTabMenuSelect === "Calender2" ? 'ml-5 calendar-container' : 'ml-5 calendar-container d-flex'}>  
          {reportTotal.typeTabMenuSelect === "Calender2" &&<header className="calendar-header">
            <button onClick={() => handlePrev("1")} style={{color:'aqua', fontSize:'2rem', width:'80px'}}>‹</button>
            <div className="calendar-title">
                <input
                  type="month"
                  onChange={e => handleMonthChange(e.target.value, "1")}
                  value={currentDate1 === "" ? "" : `${currentDate1.getFullYear()}-${String(currentDate1.getMonth() + 1).padStart(2, '0')}`}
                  className="month-input"
                />
            </div>
            <button onClick={() =>handleNext("1")} style={{color:'aqua', fontSize:'2rem', width:'80px'}}>›</button> 

            <div style={{ fontSize:'1.6rem'}}>
                <label>Same Day</label>
                <input type="checkbox" className="mr-2 ml-2" checked={option1}
                  onClick={()=> setOption1(!option1)}></input>
            </div>

          <div style={{ fontSize:'1.6rem'}}>
                <label>Fill in the gaps</label>
                <input type="checkbox" className="mr-2 ml-2"></input>
            </div>
           
            <input type="checkbox"></input>
            <input type="checkbox"></input>
            <input type="checkbox"></input>

          </header>}

           {/* {reportTotal.typeTabMenuSelect === "Calender2" && <RoomReportTotalItem2
                dayNames = {dayNames2}
                days ={days1}
                dayMain = {days1}
                dayOld1 ={dayOld1}
                dayOld2 ={dayOld2}
                option1 ={option1}
                setOption1 = {setOption1}
                type="predicted"
                currentDate={currentDate1}
                handlePrev={handlePrev}
                handleNext={handleNext}
                setCurrentDate={setCurrentDate1}
                handleMonthChange={handleMonthChange}
                getBackgroundColor= {getBackgroundColor}
                active={active}
                room = {dataBranch.room}
                setActive={setActive}
            /> }

          {reportTotal.typeTabMenuSelect === "Calender2" && <RoomReportTotalItem2
                dayNames = {dayNames2}
                days ={days1}
                dayMain = {days1}
                dayOld1 ={dayOld1}
                dayOld2 ={dayOld2}
                option1 ={option1}
                setOption1 = {setOption1}
                type="1"
                currentDate={currentDate1}
                handlePrev={handlePrev}
                handleNext={handleNext}
                setCurrentDate={setCurrentDate1}
                handleMonthChange={handleMonthChange}
                getBackgroundColor= {getBackgroundColor}
                active={active}
                room = {dataBranch.room}
                setActive={setActive}
            />} */}

                 
          <div className='mt-2'>
           {reportTotal.typeTabMenuSelect === "Calender2" ? 
           <RoomReportTotalItem2
                  dayNames = {dayNames2}
                  days ={dayOld1}
                  dayMain = {days1}
                  dayOld1 ={dayOld1}
                  dayOld2 ={dayOld2}
                  type="2"
                  option1 ={option1}
                  currentDate={currentDate1}
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                  setCurrentDate={setCurrentDate1}
                  handleMonthChange={handleMonthChange}
                  getBackgroundColor= {getBackgroundColor}
                  active={active}
                  room = {dataBranch.room}
                  setActive={setActive}
              /> 
              : <RoomReportTotalItem
                  dayNames = {dayNames}
                  days ={days1}
                  type="1"
                  option1 ={option1}
                  currentDate={currentDate1}
                  handlePrev={handlePrev}
                  handleNext={handleNext}
                  setCurrentDate={setCurrentDate1}
                  handleMonthChange={handleMonthChange}
                  getBackgroundColor= {getBackgroundColor}
                  active={active}
                  room = {dataBranch.room}
                  setActive={setActive}
              /> }
            </div>

          {/* Tablet 2 */}
          <div className={reportTotal.typeTabMenuSelect === "Calender" ? 'ml-5 mt-2' : 'mt-2 ml-5'}>
            {reportTotal.typeTabMenuSelect === "Calender2" ? <RoomReportTotalItem2
                    dayNames = {dayNames2}
                    days ={dayOld2}
                    dayMain = {days1}
                    dayOld1 ={dayOld1}
                    dayOld2 ={dayOld2}
                    type="3"
                    option1 ={option1}
                    currentDate={currentDate1}
                    handlePrev={handlePrev}
                    handleNext={handleNext}
                    setCurrentDate={setCurrentDate1}
                    handleMonthChange={handleMonthChange}
                    getBackgroundColor= {getBackgroundColor}
                    active={active}
                    room = {dataBranch.room}
                    setActive={setActive}
                /> : <RoomReportTotalItem
                    dayNames = {dayNames}
                    days ={days2}
                    type="2"
                    option1 ={option1}
                    currentDate={currentDate2}
                    handlePrev={handlePrev}
                    handleNext={handleNext}
                    setCurrentDate={setCurrentDate2}
                    handleMonthChange={handleMonthChange}
                    getBackgroundColor= {getBackgroundColor}
                    active={active}
                    room = {dataBranch.room}
                    setActive={setActive}
                />}
          </div>
          
          {/* <RoomReportTotalItem
                dayNames = {dayNames}
                days ={days2}
                type="2"
                currentDate={currentDate2}
                handlePrev={handlePrev}
                handleNext={handleNext}
                handleMonthChange={handleMonthChange}
                setCurrentDate={setCurrentDate2}
                getBackgroundColor= {getBackgroundColor}
                active={active}
                room = {dataBranch.room}
                setActive={setActive}
            /> */}
        </div>}
      </ div>}

      {reportTotal.typeTabMenuSelect === "DETAILS" && <ReportMemberShipAdmin /> }

      {reportTotal.typeTabMenuSelect === "VOUCHER" && <VoucherMemberShip /> }

   </div>
  );
};

export default RoomReportTotal;
